var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareAboutUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -1442.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/About-us",
    transform: "translate(3498.000000, 1442.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.000175,12.1247578 L14.000175,21.4258428 C14.000175,24.3660358 15.6431955,27.0708196 18.2862286,28.5123377 C16.8232103,30.3258603 14.559182,31.5 12.00015,31.5 L12.00015,31.5 L2.84217094e-14,31.5 L2.84217094e-14,19.8748547 C2.84217094e-14,15.5948637 3.58204478,12.1247578 8.0001,12.1247578 L8.0001,12.1247578 L14.000175,12.1247578 Z M25.59992,12.1251453 C29.1349642,12.1251453 32,14.9006488 32,18.3242541 L32,18.3242541 L32,27.6253391 L22.40088,27.6253391 C18.8658358,27.6253391 15.9998,24.8498356 15.9998,21.4262303 L15.9998,21.4262303 L15.9998,12.1251453 Z M10.000125,0.5 C12.7621595,0.5 15.0001875,2.66905836 15.0001875,5.34381055 C15.0001875,8.01856273 12.7621595,10.1876211 10.000125,10.1876211 C7.23809048,10.1876211 5.0000625,8.01856273 5.0000625,5.34381055 C5.0000625,2.66905836 7.23809048,0.5 10.000125,0.5 Z M24.0003,2.43752422 C26.2093276,2.43752422 28.00035,4.17257716 28.00035,6.31257266 C28.00035,8.45256816 26.2093276,10.1876211 24.0003,10.1876211 C21.7912724,10.1876211 20.00025,8.45256816 20.00025,6.31257266 C20.00025,4.17257716 21.7912724,2.43752422 24.0003,2.43752422 Z",
    id: 106
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareAboutUs);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-about-us.903bced2.svg";
export { ForwardRef as ReactComponent };